var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bubble_tip"},[_c('span',{staticClass:"word"},[_vm._v("查看详情")]),_vm._v(" "),_c('span',{staticClass:"triangle"})])}]

export { render, staticRenderFns }